import React from "react";

export default function Logo({ size = 36, withText = true }) {
  return (
    <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-transform group-hover:rotate-[-4deg]"
      >
        <defs>
          <linearGradient id="bsg" x1="0" y1="0" x2="64" y2="64">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#064E3B" />
          </linearGradient>
        </defs>
        {/* Baobab trunk */}
        <path
          d="M30 60 L30 36 C26 34 22 30 22 24 C22 18 26 14 32 14 C38 14 42 18 42 24 C42 30 38 34 34 36 L34 60 Z"
          fill="url(#bsg)"
        />
        {/* Baobab crown - three nodes (network roots upward) */}
        <circle cx="20" cy="14" r="4" fill="#10B981" />
        <circle cx="32" cy="6" r="4" fill="#10B981" />
        <circle cx="44" cy="14" r="4" fill="#10B981" />
        {/* Connecting branches */}
        <path
          d="M24 16 L30 12 M40 16 L34 12 M28 18 L32 8"
          stroke="#10B981"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        {/* Roots */}
        <path
          d="M30 60 L20 62 M34 60 L44 62 M32 60 L32 64"
          stroke="#10B981"
          strokeWidth="2"
          strokeLinecap="round"
        />
        {/* Shield mark */}
        <path
          d="M32 38 L36 40 V44 C36 46 34 47.5 32 48 C30 47.5 28 46 28 44 V40 Z"
          fill="#050A07"
          stroke="#EAB308"
          strokeWidth="1.2"
        />
      </svg>
      {withText && (
        <div className="leading-none">
          <div className="font-display text-[22px] font-bold tracking-tight">
            Baob<span className="text-emerald-400">Sec</span>
          </div>
          <div className="text-[10px] text-gray-500 tracking-[0.18em] uppercase mt-0.5">
            Cyber · Gouvernance
          </div>
        </div>
      )}
    </a>
  );
}
